import React from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LOOKUP from 'constants/lookup';
import { mapOrdersPatient } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';

const PatientTabOrders = ({ orders, pagination, changePage, handleChange, orderDropDownValue, ...props }) => {
    const compName = "orders";

    return (
        <div className="product-content" style={{ padding: 0 }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <Select
                    value={orderDropDownValue}
                    onChange={handleChange}
                    label="Order Types"
                >
                    <MenuItem value={1}>All Orders</MenuItem>
                    <MenuItem value={2}>Online Orders</MenuItem>
                    <MenuItem value={3}>POS Orders</MenuItem>
                </Select>
            </FormControl>
            <GenericTable
                className="table_center"
                multiSelectable={false}
                enableSelectAll={false}
                displaySelectAll={false}
                adjustForCheckbox={false}
                displayRowCheckbox={false}
                selectable={false}
                stripedRows={true}
                columns={LOOKUP.menu.admin.patientOrderListTableColumns}
                rows={mapOrdersPatient(orders.list)}
            />
            <Pagination
                length={orders.total || 0}
                itemsPerPage={pagination.itemsPerPage}
                activePage={pagination.activePage}
                onPageChange={(e) => changePage(e, compName)} />
        </div>
    );
};

export default PatientTabOrders;
